import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import {TimezonePipe} from './timezone.pipe';
import { Base64DecodePipe } from './base-64-decode.pipe';
import { SafeUrlPipe } from './safe-url.pipe';


@NgModule({
  declarations: [
    TimezonePipe,
    Base64DecodePipe,
    SafeUrlPipe
  ],
  imports: [
    CommonModule
  ],
  exports: [
    TimezonePipe,
    Base64DecodePipe,
    SafeUrlPipe
  ]
})
export class CommonPipeModule { }
